module.exports = __webpack_public_path__ + "media/images/devenir-hote-766f62c5e2f084fa107f932b48edc755.webp";